import {
    NinchatActionType,
    NinchatDescribeUserAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatUserFoundEvent} from 'api/types/events'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const describeUser = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDescribeUserAction}`,
    async (arg: NinchatActionParams<NinchatDescribeUserAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDescribeUserAction

        try {
            return await ninchatClient.send(params) as NinchatUserFoundEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
